(function() {
    window.hypObj = (function() {
        function hypObj() {}

        hypObj.api_url = "https://sp-seller.webkul.com/";
        hypObj.pickup_val = false;
        hypObj.prod_ids = Array();
        hypObj.current_page_path = window.location.pathname;
        hypObj.is_multiple_filter = 1;
        hypObj.arr_filter = [];
        console.log(window.wk_hyperlocal_matching_type);
        hypObj.wk_hyperlocal_matching_type =  (typeof window.wk_hyperlocal_matching_type !== 'undefined') ? parseInt(window.wk_hyperlocal_matching_type) || 1 : 1;
        console.log(hypObj.wk_hyperlocal_matching_type);

        console.log(hypObj.current_page_path);
        if (typeof origin_url == 'undefined')
            origin_url = window.location.origin;

        hypObj.showLoader = function() {
            hypObj.$(".mp-loader").css("display", "block");
            if (typeof hyobj_max_loader_show_sec !== 'undefined')
                setTimeout(()=>{hypObj.$(".mp-loader").css("display", "none");},window.hyobj_max_loader_show_sec*1000);
        };
        hypObj.removeLoader = function() {
            hypObj.$(".mp-loader").css("display", "none");
        };
        hypObj.getAllSellers = function() {
            // var origin_url = window.location.origin;
            window.location.href = window.location.origin + '/pages/seller-profile';
        }
        
            hyobj_allproducts_url = '/pages/allproducts';

        // delete all old local storage related to hyperlocal product listing
        if(hypObj.current_page_path.length === 0 || hypObj.current_page_path === "/"){
            var wk_seller_details_for_hyp = window.localStorage.getItem('wk_seller_details_for_hyp');
            if (wk_seller_details_for_hyp !== 'undefined'){
                localStorage.removeItem('wk_seller_details_for_hyp');
            }
        }

        hypObj.getAllProducts = function() {
            if(window.location.href.indexOf(hyobj_allproducts_url) > -1 ) {
                // get seller details by customer location
                hypObj.getSellerDetailsByCustLocation();
            }
            else{
                localStorage.removeItem('wk_product_pagination_detail');
                window.location.href = window.location.origin +hyobj_allproducts_url;
            }
        }
        
        
        hypObj.getSellerDetailsByCustLocation = function() {
            var wk_customer_location = window.localStorage.getItem('wk_customer_location');
            if (wk_customer_location === 'undefined' || wk_customer_location === null || wk_customer_location === ''){
                if (typeof origin_url == 'undefined' || origin_url == '' || origin_url == null)
                    window.location.href = window.location.origin;
                else
                    window.location.href = origin_url;
                hypObj.removeAllLocalStorage();
            }
            wk_customer_location = JSON.parse(wk_customer_location);
            console.log(wk_customer_location);
            var wk_seller_details_for_hyp = window.localStorage.getItem('wk_seller_details_for_hyp');
            if (wk_seller_details_for_hyp === 'undefined' || wk_seller_details_for_hyp === null || wk_seller_details_for_hyp === ''){
                hypObj.$.ajax({
                    url: hypObj.api_url + 'index.php?p=hyperlocal_mp',
                    async: false,
                    cache: false,
                    dataType: 'jsonp',
                    contentType: 'application/json',
                    jsonpCallback: 'getSellerDetailsByCustLocation',
                    data: {
                        shop: hypObj.shop_name,
                        lat: wk_customer_location.lat,
                        lng: wk_customer_location.lng,
                        zipcode: localStorage.getItem('wk_hyperlocal_zipcode') || '',
                        matching_type: hypObj.wk_hyperlocal_matching_type
                    },
                    beforeSend: function() {
                        hypObj.showLoader();
                    },
                    success: function(data) {
                        if (data == 'denied')
                            hypObj.$('#wk_rest_products').html('<b class="no_product_found">' + no_product_found + '</b>').show();
                        else {
                            var sellerIds = new Array();
                            var wk_seller_stores = new Array();
                            let index;                                    
                            let count = 0;
                            if(data.seller_details != undefined){                                
                                window.localStorage.setItem('wk_seller_details_for_hyp', JSON.stringify(data.seller_details));
                                window.localStorage.setItem('wk_seller_ids_str_hyp', data.seller_ids_str);
                                for (index in data.seller_details) {
                                    sellerIds[count] = data.seller_details[index].id_seller;
                                    wk_seller_stores[count] = data.seller_details[index].sp_store_name;
                                    count++;
                                }
                                window.localStorage.setItem("wk_seller_ids", JSON.stringify(sellerIds));
                                window.localStorage.setItem("wk_seller_stores", JSON.stringify(wk_seller_stores));
                                if(data.slotstime != undefined){
                                    data.slotstime = hypObj.fillSellerTimeSlotTable(data.slotstime);
                                    window.localStorage.setItem("wk_seller_slottime", JSON.stringify(data.slotstime));
                                    hypObj.wk_seller_slottime = data.slotstime;
                                }
                                window.localStorage.setItem('wk_encrypted_seller_ids', data.wk_encrypted_seller_ids);
                            }
                            else{
                                window.localStorage.setItem('wk_seller_details_for_hyp', '{}');
                                window.localStorage.setItem('wk_seller_ids_str_hyp', '');
                                window.localStorage.setItem('wk_encrypted_seller_ids', '');
                                window.localStorage.setItem("wk_seller_ids", JSON.stringify(sellerIds));
                                window.localStorage.setItem("wk_seller_stores", JSON.stringify(wk_seller_stores));
                            }
                            hypObj.getAllProductsDetailBySellerIds(0,true);
                        }
                    },
                    error: function(xhr, ajaxOptions, thrownError) {
                        console.log(xhr.status);
                        console.log(thrownError);
                        hypObj.removeLoader();
                    },
                    complete: function() {
                        hypObj.removeLoader();
                    }
                });
            }
            else
                hypObj.getAllProductsDetailBySellerIds(0,true);
        }
        hypObj.removeAllLocalStorage = function() {
            localStorage.removeItem('wk_product_pagination_detail');
            localStorage.removeItem('wk_seller_ids');
            localStorage.removeItem('wk_customer_location');
            localStorage.removeItem('wk_seller_details_for_hyp');
            localStorage.removeItem('wk_seller_ids_str_hyp');
            localStorage.removeItem('wk_seller_slottime');
            localStorage.removeItem('wk_encrypted_seller_ids');
            localStorage.removeItem('wk_seller_stores');
            localStorage.removeItem('wk_hyperlocal_zipcode');
        }
        
        if (typeof update_location == 'undefined')
            update_location = "Update Location";
        
        if (typeof no_product_found  == 'undefined')
            no_product_found  = "No Product Found!";
        
        if (typeof listing_product_limit == 'undefined')
            listing_product_limit = 16;

        hypObj.wk_hl_200 = 195;
        // HYPERLOCAL calculated distance by google map distancematrix api
        // hypObj.getAllSellersAddr = function(user) {
        //     // console.log(user);
        //     hypObj.$.ajax({
        //         url: hypObj.api_url + 'index.php?p=hyperlocal_mp',
        //         async: false,
        //         cache: false,
        //         dataType: 'jsonp',
        //         contentType: 'application/json',
        //         jsonpCallback: 'getAllSellersAddr',
        //         data: {
        //             shop: hypObj.shop_name,
        //             cust_addr: user
        //         },
        //         beforeSend: function() {
        //             hypObj.showLoader();
        //         },
        //         success: function(data) {
        //             console.log(data);
        //             if (data == 'denied')
        //             hypObj.$('#wk_rest').html('<p style="text-align:center;">No Resturant Found!</p>');
        //             else
        //             {
        //                 var count = 0;
        //                 var sellerIds = new Array();
        //                 data.forEach(function(item, index){ 
        //                     var service = new google.maps.DistanceMatrixService();
        //                     service.getDistanceMatrix({
        //                         origins: [user],
        //                         destinations: [item.address],
        //                         travelMode: google.maps.TravelMode.DRIVING,
        //                         unitSystem: google.maps.UnitSystem.METRIC,
        //                         avoidHighways: false,
        //                         avoidTolls: false
        //                         }, function (response, status) {
        //                             if (status == google.maps.DistanceMatrixStatus.OK && response.rows[0].elements[0].status != "ZERO_RESULTS") {
        //                                 var distance = response.rows[0].elements[0].distance.text;
        //                                 var duration = response.rows[0].elements[0].duration.text;
        //                             var res = distance.split(" ");
        //                             if(res[1] == 'm')
        //                                 res[0] = res[0]/1000;
        //                             if(parseInt(item.max_delv_dist) >= res[0])
        //                             {
        //                                 sellerIds[count] = item.id_shop;
        //                                 if(count < 6)
        //                                     hypObj.$('#wk_rest').prepend('<div class="card col-md-3 col-lg-3 col-sm-5 col-xs-10 col-10 text-center " style="margin:10px;box-shadow: 0 6px 12px 0 rgba(0,0,0,0.2);height:210px"> <a href="/pages/seller-profile'+item.url_type+item.store_name_handle+'"><img src="'+item.store_logo+'"style="width:100%;height:150px;margin-top:10px;margin-bottom:10px;"> <div class="container-fluid"><h6><b>'+item.sp_store_name+'</b></h6></div></a></div>');
        //                                 count++;
        //                             }
        //                         } 
        //                     });
        //                 });
        //             }
        //             setTimeout(function afterFiveSeconds(){
        //                 localStorage.setItem("wk_seller_ids", JSON.stringify(sellerIds));
        //                 var total_rest = hypObj.$('#wk_nearby_rest').val();
        //                 var total = total_rest.replace('#COUNT#',count);
        //                 if(count > 6)
        //                 {
        //                     hypObj.$("#wk_rest_all").css("display","block");
        //                     hypObj.$("#wk_rest_count_zero").html('');
        //                     hypObj.$("#wk_rest_count").html('<b>'+total+'</b>');
        //                 }
        //                 else 
        //                 {
        //                     hypObj.$("#wk_rest_all").css("display","none");
        //                     hypObj.$("#wk_rest_count_zero").html('');
        //                     if(count == 0)
        //                         hypObj.$("#wk_rest_count_zero").html('<b>No Restaurants available</b>');

        //                 }


        //             },1500)//increase timeout if condition gets bigger
        //         },
        //         error: function(xhr, ajaxOptions, thrownError) {
        //             console.log(xhr.status);
        //             console.log(thrownError);
        //         },
        //         complete: function() {
        //             setTimeout(function afterTwoSeconds(){
        //                 hypObj.removeLoader();
        //             },3000);
        //         }
        //     });
        // }
        hypObj.distance = function distance(lat1, lon1, lat2, lon2) {
            if ((lat1 == lat2) && (lon1 == lon2)) {
                return 0;
            } else {
                var radlat1 = Math.PI * lat1 / 180;
                var radlat2 = Math.PI * lat2 / 180;
                var theta = lon1 - lon2;
                var radtheta = Math.PI * theta / 180;
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                    dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180 / Math.PI;
                dist = dist * 60 * 1.1515;
                dist = dist * 1.609344;

                return dist;
            }
        }

        hypObj.numberRangeArray = function(start, end) {
            return Array(end - start + 1).fill().map((_, idx) => start + idx)
        }
        
        hypObj.getAllProductsDetailBySellerIds = function(wk_product_current_page,is_first_time = true,sort_by = '') {
            if(hypObj.wk_seller_details_for_hyp==undefined){
                hypObj.wk_seller_details_for_hyp =  JSON.parse(window.localStorage.getItem('wk_seller_details_for_hyp'));            
            }
            if(hypObj.wk_seller_slottime == undefined){
                hypObj.wk_seller_slottime =  JSON.parse(window.localStorage.getItem('wk_seller_slottime'));
            }
            if(hypObj.wk_seller_ids_str_hyp_f==undefined){
                hypObj.wk_seller_ids_str_hyp = window.localStorage.getItem('wk_seller_ids_str_hyp');
            }
            else{
                hypObj.wk_seller_ids_str_hyp = hypObj.wk_seller_ids_str_hyp_f;
            }
            var wk_product_pd = '', wk_product_pd_ajax_data ='' ; 
            wk_product_pd = window.localStorage.getItem('wk_product_pagination_detail');
            if(!(wk_product_pd === 'undefined' || wk_product_pd === null || wk_product_pd === '')){
                wk_product_pd = JSON.parse(wk_product_pd);
                // page
                if(wk_product_current_page == 0){
                    wk_product_current_page = (wk_product_pd.page!=undefined)?wk_product_pd.page:1;
                    // wk_product_current_page = wk_product_pd.page;
                }
                // sort
                if(sort_by==''){
                    hypObj.wk_hl_sort_by = (wk_product_pd.sort_by!=undefined)?wk_product_pd.sort_by:'nearest_first';
                }
                else{
                    hypObj.wk_hl_sort_by = sort_by;
                }
            }
            else{
                wk_product_current_page = 1;
                hypObj.wk_hl_sort_by = 'nearest_first';
            }
            var wk_url_search_obj = Object.fromEntries((new URLSearchParams(window.location.search)).entries());
            wk_url_search_obj.pickup_f = (wk_url_search_obj.pickup_f != undefined && wk_url_search_obj.pickup_f)?Number(wk_url_search_obj.pickup_f):0;
            wk_url_search_obj.slot_time_f = (wk_url_search_obj.slot_time_f != undefined && wk_url_search_obj.slot_time_f)?Number(wk_url_search_obj.slot_time_f):0;
            if(is_first_time && ( wk_url_search_obj.pickup_f || wk_url_search_obj.slot_time_f)){
                wk_product_current_page = 1;
            }
            // wk_product_current_page get current page
            wk_product_pd = { 'page': wk_product_current_page, 'limit': listing_product_limit,'products_count':0,'sort_by': hypObj.wk_hl_sort_by,'shop_name':hypObj.shop_name,'seller_ids':hypObj.wk_seller_ids_str_hyp,'filter_detail':hypObj.arr_filter};
            window.localStorage.setItem('wk_product_pagination_detail', JSON.stringify(wk_product_pd));
            wk_product_pd_ajax_data = wk_product_pd;
            hypObj.wk_encrypted_seller_ids = window.localStorage.getItem('wk_encrypted_seller_ids')
            if(hypObj.wk_encrypted_seller_ids !== null && hypObj.wk_encrypted_seller_ids !== ''){
                delete wk_product_pd_ajax_data.seller_ids;
                wk_product_pd_ajax_data.wk_encrypted_seller_ids = hypObj.wk_encrypted_seller_ids;
            }
            hypObj.$.ajax({
                url: hypObj.api_url + 'index.php?p=hyperlocal_mp',
                async: false,
                cache: false,
                dataType: 'jsonp',
                contentType: 'application/json',
                jsonpCallback: 'getAllProductsDetailBySellerIds',
                data: { 
                    shop: hypObj.shop_name,
                    product_pagination: wk_product_pd_ajax_data,
                    is_first_time: is_first_time,
                    pickup_value:wk_url_search_obj.pickup_f,
                    time_slot_value:wk_url_search_obj.slot_time_f
                },
                beforeSend: function() {
                    hypObj.showLoader();
                },
                success: function(data) {
                    if (data == 'denied')
                        hypObj.$('#wk_rest_products').html('<b class="no_product_found">' + no_product_found + '</b>').show();
                    else {
                        if(data.products_count != undefined){
                            wk_product_pd.products_count = data.products_count;
                            window.localStorage.setItem('wk_product_pagination_detail',JSON.stringify(wk_product_pd));
                        }
                        if(is_first_time){
                            // seller filter
                            if(hypObj.vendor_details_arr == undefined || hypObj.vendor_details_arr == null){
                                hypObj.vendor_details_arr = new Array();
                                var check_sellerids_str = '';
                                if(data.allow_seller_ids){
                                    check_sellerids_str = data.allow_seller_ids+',';
                                }
                                if(check_sellerids_str != ''){
                                    for (var items in hypObj.wk_seller_details_for_hyp){
                                        if(check_sellerids_str.indexOf(items+',') > -1 ) {
                                            if(data.slot_details){
                                                hypObj.wk_seller_details_for_hyp[items].time_slot = (data.slot_store!=undefined&&data.slot_store[items]!=undefined&&data.slot_store[items])?data.slot_store[items]:0;
                                            }
                                            else{
                                                hypObj.wk_seller_details_for_hyp[items].time_slot = 0; 
                                            }
                                            hypObj.vendor_details_arr.push(hypObj.wk_seller_details_for_hyp[items]);
                                        }
                                    }
                                    hypObj.wk_seller_ids_str_hyp_f = data.allow_seller_ids;
                                }
                            }
                            var data_fil_details = {
                                category_details:data.category_details,
                                tag_details:data.tag_details,
                                type_details:data.type_details,
                                pickup_details:data.pickup_details,
                                slot_details:data.slot_details,
                                vendor_details:hypObj.vendor_details_arr
                            };
                            var plFiltersCompile = Handlebars.compile(hypObj.$("#mvm-hl-filters").html());
                            hypObj.$('#wk_hyp_prod_filters').html(plFiltersCompile(data_fil_details)); 
                            if(data.pickup_details){  
                                if(wk_url_search_obj.pickup_f != undefined && wk_url_search_obj.pickup_f > 0){
                                    hypObj.$("div.wk_hl_panel [data-for='store-pickup'][value='"+wk_url_search_obj.pickup_f+"']").prop('checked', true);
                                }
                            }
                            if(data.slot_details){  
                                if(wk_url_search_obj.slot_time_f != undefined && wk_url_search_obj.slot_time_f > 0){
                                    hypObj.$("div.wk_hl_panel [data-for='time-slot'][value='"+wk_url_search_obj.slot_time_f+"']").prop('checked', true);
                                }
                            }
                            var wk_acc_1 = hypObj.$('#wk-hl-filter-show').next('div').find('.wk-hl-accordion');
                            wk_acc_1.addClass("wk-active");
                            var wk_hl_panel = wk_acc_1.next('div')[0];
                            if(wk_hl_panel){
                                wk_hl_panel.style.maxHeight = ((wk_hl_panel.scrollHeight>hypObj.wk_hl_200)?hypObj.wk_hl_200:wk_hl_panel.scrollHeight) + "px";
                            }
                            hypObj.getFilterdetails(false,true);
                            if(!hypObj.$('.wk-hl-prod-list-page .wk-hl-accordion').length){
                                hypObj.$('#wk-hl-filter-empty').css('display','block');
                            }
                        }
                        
                        // product listing 
                        var data_prod_list = {
                            vendor_details:hypObj.wk_seller_details_for_hyp,
                            slot_details:data.slot_details,
                            wk_seller_slottime:hypObj.wk_seller_slottime,
                            products:data.products
                        };

                        if(data.products.length == 0 && hypObj.$('#wk_hyp_allproducts_empty').length){
                            hypObj.$('#wk_hyp_allproducts_empty').css('display','block');
                            hypObj.$('#wk_hyp_allproducts').html('');
                        }
                        else{
                            var producttListingCompile = Handlebars.compile(hypObj.$("#mvm-card-product-listing").html());
                            hypObj.$('#wk_hyp_allproducts').html(producttListingCompile(data_prod_list));                            
                            hypObj.$('#wk_hyp_allproducts_empty').css('display','none');
                        }
                        // pagination
                        var total_pages = Math.ceil(wk_product_pd.products_count/listing_product_limit);
                        // pagination work only when total pages more than one
                        if(total_pages > 1){
                            var pagination_data = {};
                            pagination_data.current_page = wk_product_current_page;
                            pagination_data.last = total_pages;
                            if (total_pages <= 7) {
                                pagination_data.pages = hypObj.numberRangeArray(1,total_pages);
                            } else if (wk_product_current_page < total_pages - 2 && wk_product_current_page > 3) {
                                pagination_data.pages = hypObj.numberRangeArray(wk_product_current_page-3,wk_product_current_page+3);
                                pagination_data.pages[0] = 1;
                                pagination_data.pages[6] = total_pages;
                            } else if (wk_product_current_page <= 3) {
                                pagination_data.pages = hypObj.numberRangeArray(1,wk_product_current_page+2);
                                pagination_data.pages[pagination_data.pages.length] = total_pages;
                            } else if (wk_product_current_page >= total_pages - 2) {
                                pagination_data.pages = hypObj.numberRangeArray(wk_product_current_page-3,total_pages);
                                pagination_data.pages[0] = 1;
                            }
                            var producttListingPagintionCompile = Handlebars.compile(hypObj.$("#mvm-card-product-listing-pagination").html());
                            hypObj.$('#wk_hyp_product_pagination').html(producttListingPagintionCompile(pagination_data));
                        }
                        else{
                            hypObj.$('#wk_hyp_product_pagination').html('');
                        }
                    }
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                    hypObj.removeLoader();
                },
                complete: function() {
                    hypObj.removeLoader();
                }
            });
        }

        hypObj.getAllSellersAddrByLocation = function(lat, lng) {
            // get listing type by pasted code
            hypObj.wk_hyp_listing_type = (hypObj.$('#wk_hyp_listing_type').length && hypObj.$('#wk_hyp_listing_type').val() == 1)?1:0;
            if(hypObj.wk_hyp_listing_type == 1){
                hypObj.getAllProducts();
            }


            // Inner function: fires the AJAX once zipcode is resolved
            var doAjax = function() {
                var zipcode = (hypObj.wk_hyperlocal_matching_type == 2) ? (localStorage.getItem('wk_hyperlocal_zipcode') || '') : '';
                hypObj.$.ajax({
                url: hypObj.api_url + 'index.php?p=hyperlocal_mp',
                async: false,
                cache: false,
                dataType: 'jsonp',
                contentType: 'application/json',
                jsonpCallback: 'getAllSellersByLocation',
                data: {
                    shop: hypObj.shop_name,
                    lat: lat,
                    lng: lng,
                    zipcode: zipcode,
                    matching_type: hypObj.wk_hyperlocal_matching_type
                },
                beforeSend: function() {
                    hypObj.showLoader();
                },
                success: function(data) {
                    if (data == 'denied')
                        hypObj.$('#wk_rest').html('<b>' + no_seller_found + '</b>');
                    else {
                        var count = 0;
                        var sellerIds = new Array();
                        var wk_seller_stores = new Array();
                        var redirect_seller_page = data[0]['redirect_seller_page'];
                        var wk_hyp_listing_type = data[0]['listing_type'];
                        // get listing type by DB
                        if(wk_hyp_listing_type == 1){
                            hypObj.getAllProducts();
                        }
                        if (typeof wk_seller_count == 'undefined')
                            wk_seller_count = 6;
                        data.forEach(function(item, index) {
                            // var distance = hypObj.distance(item.latitude, item.longitude, lat, lng);
                            // if ((item.max_delv_dist && parseInt(item.max_delv_dist) >= item.customer_distance) || (item.to_sell_global == 1 && item.allow_seller_global == 1) ) {
                                if (hypObj.$.inArray(item.id_seller, Object.values(sellerIds)) === -1) {
                                    sellerIds[count] = item.id_seller;
                                    wk_seller_stores[count] = item.sp_store_name;
                                    if (count < wk_seller_count && redirect_seller_page == 0 && wk_hyp_listing_type == 0) {
                                        if (item.shop_logo != '')
                                            hypObj.$('#wk_rest').prepend('<div data-distance="'+item.customer_distance+'" class="wk_seller_grid_hyp col-md-3 col-lg-3 col-sm-5 col-xs-10 col-10 text-center " id="wk_' + item.store_name_handle + '" style="margin:10px;box-shadow: 0 6px 12px 0 rgba(0,0,0,0.2);height:210px"> <a href="/pages/seller-profile' + item.url_type + item.store_name_handle + '"><img src="' + item.shop_logo + '"style="width:100%;height:150px;margin-top:10px;margin-bottom:10px;"> <div class="container-fluid"><h6><b>' + item.sp_store_name + '</b></h6></div></a></div>');
                                        else
                                            hypObj.$('#wk_rest').prepend('<div data-distance="'+item.customer_distance+'" class="wk_seller_grid_hyp card col-md-3 col-lg-3 col-sm-5 col-xs-10 col-10 text-center " id="wk_' + item.store_name_handle + '" style="margin:10px;box-shadow: 0 6px 12px 0 rgba(0,0,0,0.2);height:210px"> <a href="/pages/seller-profile' + item.url_type + item.store_name_handle + '"><img src="' + hypObj.api_url + "img/No-Image/No-Image-140x140.png" + '"style="width:100%;height:150px;margin-top:10px;margin-bottom:10px;"> <div class="container-fluid"><h6><b>' + item.sp_store_name + '</b></h6></div></a></div>');
                                    }
                                    count++;
                                }
                            // }
                        });
                        
                        hypObj.$('#wk_rest').find('.wk_seller_grid_hyp').sort(function(a, b) {
                            return +a.dataset.distance - +b.dataset.distance;
                        }).appendTo(hypObj.$('#wk_rest'));

                        setTimeout(function afterFiveSeconds() {
                                localStorage.setItem("wk_seller_ids", JSON.stringify(sellerIds));
                                localStorage.setItem("wk_seller_stores", JSON.stringify(wk_seller_stores));
                                if(redirect_seller_page == 1 && wk_hyp_listing_type == 0){
                                    hypObj.getAllSellers();
                                }
                                var total_rest = hypObj.$('#wk_nearby_rest').val();
                                var total = total_rest.replace('#COUNT#', count);
                                if (count > wk_seller_count) {
                                    hypObj.$("#wk_rest_all").css("display", "block");
                                    hypObj.$("#wk_rest_count_zero").html('');
                                    hypObj.$("#wk_rest_count").html('<b>' + total + '</b>');
                                } else {
                                    hypObj.$("#wk_rest_all").css("display", "none");
                                    hypObj.$("#wk_rest_count_zero").html('');
                                    if (count == 0)
                                        hypObj.$("#wk_rest_count_zero").html('<b>' + no_seller_found + '</b>');

                                }

                                
                            }, 1500) //increase timeout if condition gets bigger,
                    }
                    hypObj.checkStorePickupActive();
                    var acc = document.getElementsByClassName("wk-accordion");
                    if (acc.length > 0) {
                        if (hypObj.pickup_val != false) {
                            acc[0].classList.add("wk-active");
                            acc[0].nextElementSibling.style.maxHeight = acc[0].nextElementSibling.scrollHeight + 12 + "px";
                        }
                        var i;
                        for (i = 0; i < acc.length; i++) {
                            acc[i].addEventListener("click", function() {
                                this.classList.toggle("wk-active");
                                var wk_hl_panel = this.nextElementSibling;
                                if (wk_hl_panel.style.maxHeight) {
                                    wk_hl_panel.style.maxHeight = null;
                                } else {
                                    wk_hl_panel.style.maxHeight = wk_hl_panel.scrollHeight + 10 + "px";
                                }
                            });
                        }
                    }
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                },
                complete: function() {
                    setTimeout(function afterTwoSeconds() {
                        hypObj.removeLoader();
                    }, 1500);
                }
            });
            }; // end doAjax

            // When zipcode-based matching, ensure zipcode is resolved from lat/lng before calling
            if (hypObj.wk_hyperlocal_matching_type == 2 && !localStorage.getItem('wk_hyperlocal_zipcode')) {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ location: { lat: parseFloat(lat), lng: parseFloat(lng) } }, function(results, status) {
                // console.log(results);
                if (status === 'OK' && results.length) {
                    var postalCode = '';

                    results.forEach(function(result) {

                        if (postalCode) {
                            return;
                        }

                        result.address_components.forEach(function(component) {

                            if (
                                component.types.indexOf('postal_code') !== -1 &&
                                !postalCode
                            ) {
                                postalCode = component.short_name;
                            }

                        });

                    });

                    if (!postalCode) {
                        console.warn('wk_hyperlocal: postal code not found for reverse geocoded location');
                    }

                    localStorage.setItem('wk_hyperlocal_zipcode', postalCode);

                } else {
                    console.warn('wk_hyperlocal: reverse geocoding failed, proceeding without zipcode');
                }
                    doAjax();
                });
            } else {
                doAjax();
            }
        }

        hypObj.filterPickupDetail = function(pickup_val,only_data = false) {
            hypObj.$.ajax({
                url: hypObj.api_url + 'index.php?p=hyperlocal_mp',
                async: false,
                cache: false,
                dataType: 'jsonp',
                contentType: 'application/json',
                jsonpCallback: 'filterPickupDetail',
                data: {
                    shop: hypObj.shop_name,
                    pickup_val: pickup_val
                },
                beforeSend: function() {
                    if(!only_data)
                        hypObj.showLoader();
                },
                success: function(data) {
                    console.log(data)
                    if(only_data){
                        if (data != 'denied' && pickup_val != false) {
                            return data;
                        }
                    }
                    else{
                        if (data != 'denied' && pickup_val != false) {
                            hypObj.$('#wk_rest').children().addClass('hidden');
                            data.forEach(function(item, index) {
                                hypObj.$('#wk_' + item.store_name_handle).removeClass('hidden');
                                hypObj.$('.no_seller_found').remove();
                            })
                        } else if (pickup_val == false) {
                            hypObj.$('#wk_rest').children().removeClass('hidden');
                            hypObj.$('.no_seller_found').remove();
                        } else {
                            hypObj.$('#wk_rest').children().addClass('hidden');
                            hypObj.$('#wk_rest').append('<div class="no_seller_found"><b>' + no_seller_found + '</b></div>');
                        }
                    }
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                },
                complete: function() {
                    if(!only_data)
                        hypObj.removeLoader();
                }
            });
        }

        hypObj.searchForMultipleShipping = function(wk_customer_location) {
            hypObj.$.ajax({
                url: hypObj.api_url + 'index.php?p=hyperlocal_mp',
                async: false,
                cache: false,
                dataType: 'jsonp',
                contentType: 'application/json',
                jsonpCallback: 'searchForMultipleShipping',
                data: {
                    shop: hypObj.shop_name,
                    prod_ids: hypObj.prod_ids,
                    lat: wk_customer_location.lat,
                    lng: wk_customer_location.lng
                },
                beforeSend: function() {
                    hypObj.showLoader();
                },
                success: function(data) {

                    if (data != 'denied') {
                        count = 0;
                        data.forEach(function(item, index) {
                            hypObj.$('#wk-search-id-' + item).parent().css('display', 'block');
                            count++;

                        });
                        hypObj.$('.wk-search-count').html(count);
                    } else {
                        hypObj.$('.wk-search-hyperlocal').parent().css('display', 'block');

                    }
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                },
                complete: function() {
                    hypObj.removeLoader();
                }
            });

        }

        hypObj.restrictSearchedProduct = function(wk_customer_location, product_ids) {
            console.group('Restrict');
            console.log('shop_name :: ' + hypObj.shop_name);
            console.log(wk_customer_location);
            console.log(product_ids);
            console.groupEnd('Restrict');
            hypObj.$.ajax({
                url: hypObj.api_url + 'index.php?p=hyperlocal_mp',
                async: false,
                cache: false,
                dataType: 'jsonp',
                contentType: 'application/json',
                jsonpCallback: 'restrictSearchedProduct',
                data: {
                    shop: hypObj.shop_name,
                    prod_ids: product_ids,
                    lat: wk_customer_location.lat,
                    lng: wk_customer_location.lng
                },
                success: function(data) {
                    console.log(data);
                    if (data != 'denied') {
                        data.forEach(function(item, index) {
                            hypObj.$('.wk_hyperlocal_prod_' + item).addClass('wk_restrict_prod');
                            hypObj.$('.wk_hyperlocal_prod_' + item).css({ 'opacity': 0.5, 'background': '#CCC' });
                            hypObj.$('.wk_hyperlocal_prod_' + item + ' a').css('pointer-events', 'none');
                            hypObj.$('.wk_hyperlocal_prod_' + item + ' button').attr('disabled', 'disabled');
                        });
                    }
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                }
            });
        }

        if (typeof hyp_location_center == 'undefined')
            hypObj.hyp_location_center = { lat: 28.6418, lng: 77.3793 };
        else
            hypObj.hyp_location_center = hyp_location_center;

        hypObj.autocomplete = function() {
            var input = hypObj.$('#wk_search_rest')[0];
            var autocomplete = new google.maps.places.Autocomplete(input);
            var map = new google.maps.Map(hypObj.$('#map')[0], {
                zoom: 10,
                center: hypObj.hyp_location_center
            });
            autocomplete.bindTo('bounds', map);
            autocomplete.setFields(['place_id', 'geometry', 'name']);
            autocomplete.addListener('place_changed', function() {
                // console.log('event listen')
                console.log(update_location)
                var place = autocomplete.getPlace();
                if (typeof place.geometry !== 'undefined') {
                    var position = { 'place': place.name, 'lat': place.geometry.location.lat(), 'lng': place.geometry.location.lng() };
                    var addr = place.name.slice(0, 35);
                    if (place.name.length > 35)
                        addr += '...';
                    window.localStorage.setItem('wk_customer_location', JSON.stringify(position));
                    hypObj.$('.wk_cstm_loc').css('display', 'flex');
                    hypObj.$('#wk_customer_loc').hide();
                    hypObj.$('#wk_customer_addr input').remove();
                    hypObj.$('#wk_change_location').html('<a style="color:blue">' + update_location + '</a>');
                    hypObj.$('#wk_customer_addr').html('<img src="' + hypObj.api_url + '/img/location-icon.png" style="margin:8px 4px;max-height: 25px;max-height:25px"><h5 id="wk_addr" style="border:none;margin:10px 10px 0px 5px;">' + addr + '</h5>');
                    hypObj.$('#wk_vendors').css("display", "block");
                    hypObj.$('#wk_rest .card').remove();
                    // hypObj.getAllSellersAddr(place.name);
                    hypObj.getAllSellersAddrByLocation(place.geometry.location.lat(), place.geometry.location.lng());
                }
            });
        }
        hypObj.getFilterdetails = function(remove_all_f = false,only_filter_popup=false) {
            var str = '';
            if(remove_all_f){
                hypObj.$('.wk-hl-prod-list-page .wk_hl_panel ul li input:checked').each(function(i, value) {
                    hypObj.$(this).prop("checked", false);
                });
                hypObj.arr_filter = {}; 
            }
            
            if(!remove_all_f){
                hypObj.arr_cat_filter = [];
                hypObj.arr_tag_filter = [];
                hypObj.arr_type_filter = [];
                hypObj.arr_vendor_filter = [];
                hypObj.filter_pickup_applied = 0;
                cat_index = type_index = tag_index = vendor_index = 0;
                hypObj.$('.wk-hl-prod-list-page .wk_hl_panel ul li input:checked').each(function(i, value) {
                    var text = hypObj.$(this).parent().find("div:eq(1)").text();
                    q = hypObj.$(this).data('for');
                    if (q == "category") {
                        hypObj.arr_cat_filter[cat_index] = value.value;
                        cat_index++;
                    } else if (q == "tag") {
                        hypObj.arr_tag_filter[tag_index] = value.value;
                        tag_index++;
                    } else if (q == "type") {
                        hypObj.arr_type_filter[type_index] = value.value;
                        type_index++;
                    }else if (q == "vendor") {
                        hypObj.arr_vendor_filter[vendor_index] = value.value;
                        vendor_index++;
                    }else if (q == "store-pickup") {
                        hypObj.filter_pickup_applied = value.value;
                    }
                    var pf_q_text = (typeof wk_hl_tran != 'undefined' && wk_hl_tran[q] != undefined && wk_hl_tran[q]!='')?wk_hl_tran[q]:q;
                    temp_data = {
                        pf_q:q,
                        pf_value:value.value,
                        pf_text:text,
                        pf_q_text:pf_q_text
                    };
                    var productFilterAppiledCompile = Handlebars.compile(hypObj.$("#mvm-hl-filters-applied").html());
                    str += productFilterAppiledCompile(temp_data);
                });
                hypObj.arr_filter = { "category": hypObj.arr_cat_filter, "tag": hypObj.arr_tag_filter , "type": hypObj.arr_type_filter,"vendor":hypObj.arr_vendor_filter,"store-pickup":hypObj.filter_pickup_applied};
                
                q = "multiple_filter";
            }
            // $('#wk_hyp_allproducts').html();
            if(str == '')
                hypObj.$('#wk-hl-filter-show').css("display", "none");
            else
                hypObj.$('#wk-hl-filter-show').css("display", "block");

            hypObj.$('.wk-hl-prod-list-page #wk-hl-tag-div').html(str);
            // hypObj.$('.wk-hl-prod-list-page #search-div').val('');
            if(!only_filter_popup){
                hypObj.getAllProductsDetailBySellerIds(1,false);
            }
        }
        hypObj.loadScript = function(url, callback) {
            var script;
            script = document.createElement("script");
            script.type = "text/javascript";
            if (script.readyState) {
                script.onreadystatechange = function() {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        return callback();
                    }
                };
            } else {
                script.onload = function() {
                    return callback();
                };
            }

            script.src = url;
            return document.getElementsByTagName("head")[0].appendChild(script);
        };

        hypObj.loadjQuery = function(afterLoad) {
            return hypObj.loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.10.2/jquery.min.js", function() {
                hypObj.$ = jQuery.noConflict(true);
                hypObj.loadCss("https://fonts.googleapis.com/css?family=Raleway:400,500,600");
                return afterLoad();
            });
        };

        hypObj.checkStorePickupActive = function() {
            console.log('check')
            hypObj.$.ajax({
                url: hypObj.api_url + "index.php?p=hyperlocal_mp",
                type: 'POST',
                cache: false,
                data: {
                    'shop': hypObj.shop_name,
                    'todo': 'checkStorePickupActive'
                },
                success: function(data) {
                    if (data == 1) {
                        hypObj.$('.wk_store_pickup_filter').css('display', 'inline-block');
                    }
                    return true;
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                }
            })
        }
        hypObj.convertTimeByMinutesOffset = function (time_str) {
            // please set minute offset if time not according to browser
            if(typeof wk_hyp_slot_time_min_offset != 'undefined'){
                var time = new Date("2001/01/01 " + time_str); 
                time.setMinutes( time.getMinutes() + wk_hyp_slot_time_min_offset );
            }
            else{
                var time = new Date("2001/01/01 " + time_str + " UTC");
            }
            var hours = time.getHours();
            var min = time.getMinutes();
            if (String(hours).length == 1)
                hours = "0" + String(hours);
            if (String(min).length == 1)
                min = "0" + String(min);

            if (typeof wk_hl_slot_time_format != 'undefined' && wk_hl_slot_time_format == 12){
                let ampm = hours >= 12 ? wk_hl_tran['am'] : wk_hl_tran['pm'];
                hours = hours % 12;
                if (String(hours).length == 1)
                    hours = "0" + String(hours);
                return hours + ":" + min + " " +ampm;
            }
            return hours + ":" + min;
        }
        hypObj.fillSellerTimeSlotTable = function (seller_time_slot) {
            var converted_slot = {};
            if(typeof wk_hl_show_only_curr_day_slot != 'undefined'){
                hypObj.wk_hl_show_only_curr_day_slot = parseInt(wk_hl_show_only_curr_day_slot);
            }
            else{
                hypObj.wk_hl_show_only_curr_day_slot = 0;
            }
            var dayNtimeValue = hypObj.getDayNtimeNumber();
            for (var seller_id in seller_time_slot) {
                let day_slots_str = '';
                for (var day in seller_time_slot[seller_id]) {
                    if (hypObj.wk_hl_show_only_curr_day_slot && dayNtimeValue.day != day){
                        continue;
                    }
                    day_slots = seller_time_slot[seller_id][day];
                    let curr_d = '';
                    let slots_str='';
                    for (var slot in day_slots) {
                        if (day_slots[slot]['o'] != "") {
                            var o_time = hypObj.convertTimeByMinutesOffset(day_slots[slot]['o']);
                            var c_time = hypObj.convertTimeByMinutesOffset(day_slots[slot]['c']);
                            slots_str = slots_str + o_time + " - " + c_time + ' ,';
                        }
                    }
                    if(dayNtimeValue.day == day){
                        curr_d = "curr-d";
                    }
                    if(slots_str != ''){
                        day_slots_str =  day_slots_str+'<p class="wk-hl-slot-'+day+'-text '+curr_d+'">'+wk_hl_tran['day'+day]+' - '+slots_str.slice(0, -1)+'</p>';
                    }
                }
                if(day_slots_str != ''){
                    converted_slot[seller_id] = day_slots_str;
                }
            }
            return converted_slot;
        }
        hypObj.getDayNtimeNumber = function () {
            var time = new Date();
            var day = time.getDay();
            if (day == 0) // for sunday it give value
                day = 7;
            var h = time.getHours();
            var m = time.getMinutes();
            var time_str = h + ':' + m;
            return { "day": day, "time": time_str };
        }
        hypObj.getMinOffset = function (t) {
            var sign = t.slice(0, 1);
            t = t.slice(1, t.length);
            var a = t.split(':');
            if(sign==='-'){
                return -1*((parseInt(a[0]) * 60 ) + parseInt(a[1]));
            }
            return ((parseInt(a[0]) * 60 ) + parseInt(a[1]));

        }

        hypObj.loadCss = function(url) {
            var head = document.getElementsByTagName('head')[0], // reference to document.head for appending/ removing link nodes
                link = document.createElement('link'); // create the link node
            link.setAttribute('href', url);
            link.setAttribute('rel', 'stylesheet');
            link.setAttribute('type', 'text/css');

            head.appendChild(link); // insert the link node into the DOM and start loading the style sheet
            return link; // return the link node;
        }
        return hypObj;
    })();
    hypObj.loadjQuery(function() {
        hypObj.$(document).ready(function() {
            map_key = window.localStorage.getItem('wk_mvm_map_access_key');
            if (map_key === 'undefined' || map_key === null || map_key === '')
                map_key = hypObj.$("#wk_map_key").val();
            hyp_google_extra_para = (typeof hyp_google_extra_para == 'undefined' || hyp_google_extra_para == '' || hyp_google_extra_para == null) ? '' :'&' + hyp_google_extra_para ;

            hypObj.loadScript("//maps.googleapis.com/maps/api/js?key=" + map_key + "&libraries=places"+hyp_google_extra_para, function() {
                window.localStorage.setItem('wk_mvm_map_access_key', map_key);
                hypObj.url_obj = document.URL;
                hypObj.url_obj = hypObj.url_obj.split("/");
                hypObj.page = hypObj.url_obj[hypObj.url_obj.length - 2];
                hypObj.handle = hypObj.url_obj[hypObj.url_obj.length - 1];
                hypObj.handle_pagination = hypObj.handle.split('?');
                hypObj.handle_without_pagination = hypObj.handle_pagination[0];
                hypObj.shop_name = Shopify.shop;
                var wk_customer_location = window.localStorage.getItem('wk_customer_location');

                if (wk_customer_location && wk_customer_location.length != 0) {
                    wk_customer_location = JSON.parse(wk_customer_location);
                    hypObj.$('.wk_cstm_loc').css('display', 'flex');
                    console.log(update_location)
                    hypObj.$('#wk_change_location').html('<a style="color:blue">' + update_location + '</a>');
                    hypObj.$('#wk_customer_addr input').remove();
                    var loc = wk_customer_location.place.slice(0, 35);
                    if (wk_customer_location.place.length > 35)
                        loc += "...";
                    hypObj.$('#wk_customer_addr').html('<img src="' + hypObj.api_url + '/img/location-icon.png" style="margin:8px 4px;max-height: 25px;max-height:25px"><h5 id="wk_addr" style="border:none;margin:10px 10px 0px 5px;">' + loc + '</h5>');
                }
                var customer_address = "";
                if (wk_customer_location && wk_customer_location.length != 0 && hypObj.$('#wk_hyp_allproducts').length){
                    hypObj.getAllProducts();
                }
                else if (wk_customer_location && wk_customer_location.length != 0 && hypObj.$('#wk_search_rest').length) {
                    // wk_customer_location = JSON.parse(wk_customer_location);
                    if(hypObj.$('#wk_hyp_listing_type').length && hypObj.$('#wk_hyp_listing_type').val() == 1){
                        hypObj.$('#wk_customer_loc').hide();
                        hypObj.$('#wk_vendors').hide();
                        hypObj.$('#wk_hyp_products_listing').show();
                    }else if(hypObj.$('#wk_hyp_listing_type').length && hypObj.$('#wk_hyp_listing_type').val() == 2 && hypObj.$('#wk_hyp_seller_profile_listing').length){
                        hypObj.$('#wk_customer_loc').hide();
                        hypObj.$('#wk_hyp_seller_profile_listing').show();
                    }
                    else{
                        hypObj.$('#wk_customer_loc').hide();
                        hypObj.$('#wk_vendors').css("display", "block");
                        hypObj.$('#wk_rest .card').remove();
                        // hypObj.getAllSellersAddr(place.name);
                        hypObj.getAllSellersAddrByLocation(wk_customer_location.lat, wk_customer_location.lng);
                    }
                } else if (hypObj.$('#wk_search_rest').length) {
                    hypObj.$('#wk_customer_loc').css("display", "block");
                    hypObj.$('#wk_customer_loc').css({ 'margin-top': "-55px", "margin-bottom": "-55px" });
                    hypObj.$('#find_food').attr('disabled', 'disabled');
                    hypObj.$('#wk_search_rest').keyup(function() {
                        customer_address = hypObj.$(this).val();
                        if (customer_address.length == 0)
                            hypObj.$('#find_food').attr('disabled', 'disabled');
                        else
                            hypObj.$('#find_food').removeAttr('disabled');
                    });
                    hypObj.autocomplete();
                }
                if (hypObj.$('.wk-search-hyperlocal').length > 0 && wk_customer_location && wk_customer_location.length != 0) {
                    hypObj.$('.wk-search-hyperlocal').each(function(val) {
                        val = hypObj.$(this).attr('data-value');
                        hypObj.prod_ids.push(val);
                    });
                    hypObj.$('.wk-search-hyperlocal').parent().css('display', 'none');
                    hypObj.searchForMultipleShipping(wk_customer_location);

                }
                // if location not set on product lisiting
                if (wk_customer_location == null && hypObj.$('#wk_hyp_allproducts').length){
                    hypObj.$('#wk_hyp_set_loc').css("display", "block");
                }
            })
            hypObj.$('body').on('click', '#find_food', function() {
                var customer_addr = hypObj.$('#wk_search_rest').val();
                hypObj.$('.wk_cstm_loc').css('display', 'flex');
                hypObj.$('#wk_customer_addr input').remove();
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'address': customer_addr }, function(results, status) {
                    if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                        // set it to the correct, formatted address if it's valid
                        hypObj.$('#wk_customer_loc').hide();
                        hypObj.$('#wk_vendors').css("display", "block");
                        hypObj.$('#wk_rest .card').remove();
                        customer_addr = results[0].formatted_address;
                        var addr = customer_addr.slice(0, 35);
                        if (customer_addr.length > 35)
                            addr += '...';
                        hypObj.getAllSellersAddrByLocation(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                        hypObj.$('#wk_change_location').html('<a style="color:blue">' + update_location + '</a>');
                        hypObj.$('#wk_customer_addr').html('<img src="' + hypObj.api_url + '/img/location-icon.png" style="margin:8px 4px;max-height: 25px;max-height:25px"><h5 id="wk_addr" style="margin:10px 10px 0px 5px;">' + addr + '</h5>');
                        var position = { 'place': results[0].formatted_address, 'lat': results[0].geometry.location.lat(), 'lng': results[0].geometry.location.lng() };
                        window.localStorage.setItem('wk_customer_location', JSON.stringify(position));
                    } else {
                        hypObj.$('#wk_change_location').html('<a style="color:blue">' + update_location + '</a>');
                        hypObj.$('#wk_customer_addr').html('<h5 id="wk_addr" style="margin:10px 10px 0px 5px;" >Unavailable location</h5>');
                    }
                });
            })

            hypObj.$('body').on('click', '#wk_use_my_location', function() {
                hypObj.$('.wk_cstm_loc').css('display', 'flex');
                hypObj.$('#wk_customer_addr input').remove();
                // console.log(navigator.geolocation)
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function(loc) {
                        lat = loc.coords.latitude;
                        lng = loc.coords.longitude;
                        var geocoder = new google.maps.Geocoder();
                        var latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

                        geocoder.geocode({ location: latlng }, function(results, status) {
                            if (status === "OK") {
                                if (results[0]) {
                                    hypObj.$('#wk_customer_loc').hide();
                                    hypObj.$('#wk_vendors').css("display", "block");
                                    hypObj.$('#wk_rest .card').remove();
                                    customer_addr = results[0].formatted_address;
                                    var addr = customer_addr.slice(0, 35);
                                    if (customer_addr.length > 35)
                                        addr += '...';
                                    hypObj.getAllSellersAddrByLocation(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                                    hypObj.$('#wk_change_location').html('<a style="color:blue">' + update_location + '</a>');
                                    hypObj.$('#wk_customer_addr').html('<img src="' + hypObj.api_url + '/img/location-icon.png" style="margin:8px 4px;max-height: 25px;max-height:25px"><h5 id="wk_addr" style="margin:10px 10px 0px 5px;">' + addr + '</h5>');
                                    var position = { 'place': results[0].formatted_address, 'lat': results[0].geometry.location.lat(), 'lng': results[0].geometry.location.lng() };
                                    window.localStorage.setItem('wk_customer_location', JSON.stringify(position));
                                } else {
                                    hypObj.$('#wk_change_location').html('<a style="color:blue">' + update_location + '</a>');
                                    hypObj.$('#wk_customer_addr').html('<h5 id="wk_addr" style="margin:10px 10px 0px 5px;" >Unavailable location</h5>');
                                }
                            }
                        });

                    });
                }
            })



            hypObj.$('body').on('submit', '.wk_search_fld', function(event) {
                event.preventDefault();
                var customer_addr = hypObj.$('#wk_search_rest').val();
                hypObj.$('.wk_cstm_loc').css('display', 'flex');
                hypObj.$('#wk_customer_addr input').remove();
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({ 'address': customer_addr }, function(results, status) {
                    if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                        // set it to the correct, formatted address if it's valid
                        hypObj.$('#wk_customer_loc').hide();
                        hypObj.$('#wk_vendors').css("display", "block");
                        hypObj.$('#wk_rest .card').remove();
                        customer_addr = results[0].formatted_address;
                        var addr = customer_addr.slice(0, 35);
                        if (customer_addr.length > 35)
                            addr += '...';
                        hypObj.getAllSellersAddrByLocation(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                        hypObj.$('#wk_change_location').html('<a style="color:blue">' + update_location + '</a>');
                        hypObj.$('#wk_customer_addr').html('<img src="' + hypObj.api_url + '/img/location-icon.png" style="margin:8px 4px;max-height: 25px;max-height:25px"><h5 id="wk_addr" style="margin:10px 10px 0px 5px;">' + addr + '</h5>');
                        var position = { 'place': results[0].formatted_address, 'lat': results[0].geometry.location.lat(), 'lng': results[0].geometry.location.lng() };
                        window.localStorage.setItem('wk_customer_location', JSON.stringify(position));
                    } else {
                        hypObj.$('#wk_change_location').html('<a style="color:blue">' + update_location + '</a>');
                        hypObj.$('#wk_customer_addr').html('<h5 id="wk_addr" style="margin:10px 10px 0px 5px;" >Unavailable location</h5>');
                    }
                });
            })

            // hypObj.$('body').on('click', '#wk_addr', function(){
            //     window.location.href = window.location.origin;
            // })

            hypObj.$('body').on('click', '#wk_change_location', function() {
                hypObj.$('.wk_cstm_loc').css('display', 'none');
                hypObj.removeAllLocalStorage();
                if (typeof origin_url == 'undefined' || origin_url == '' || origin_url == null)
                    window.location.href = window.location.origin;
                else
                    window.location.href = origin_url;
            });

            hypObj.$('body').on('click', 'div.wk_hyperlocal_pickup input', function(e) {
                hypObj.parentObj = hypObj.$(this).parent().parent();
                hypObj.$('div.wk_hyperlocal_pickup input').not(this).prop('checked', false);

                if (typeof hypObj.$(this).prop('checked') != 'undefined' && hypObj.$(this).prop('checked') == false) {
                    hypObj.pickup_val = false;
                } else {
                    hypObj.pickup_val = hypObj.$(this).parent().children().siblings(':first-child').val();
                }
                hypObj.filterPickupDetail(hypObj.pickup_val);
            });


            hypObj.$('.wk-hl-prod-list-page').on('click', 'div.wk_hl_panel input', function(event) {
                hypObj.parentObj = hypObj.$(this).parent().parent();
                // check filter store pickup seller filter 
                var for_type =  hypObj.$(this).data('for');
                if(for_type == 'store-pickup' || for_type == 'time-slot'){
                    var wkQueryParams = new URLSearchParams(window.location.search);
                    if(for_type == 'store-pickup'){
                        hypObj.$("div.wk_hl_panel [data-for='store-pickup']").not(this).prop('checked', false);
                        if (typeof hypObj.$(this).prop('checked') != 'undefined' && hypObj.$(this).prop('checked') == false) {
                            hypObj.pickup_val = false;
                        } else {
                            hypObj.pickup_val = hypObj.$(this).parent().children().siblings(':first-child').val();
                        }
                        if(hypObj.pickup_val){
                            wkQueryParams.set("pickup_f", hypObj.$(this).val());
                        }
                        else{
                            wkQueryParams.delete('pickup_f');
                        }
                    }
                    else if(for_type == 'time-slot'){
                        hypObj.$("div.wk_hl_panel [data-for='time-slot']").not(this).prop('checked', false);
                        if (typeof hypObj.$(this).prop('checked') != 'undefined' && hypObj.$(this).prop('checked') == false) {
                            hypObj.time_slot_value = false;
                        } else {
                            hypObj.time_slot_value = hypObj.$(this).parent().children().siblings(':first-child').val();
                        }
                        if(hypObj.time_slot_value){
                            wkQueryParams.set("slot_time_f", hypObj.$(this).val());
                        }
                        else{
                            wkQueryParams.delete('slot_time_f');
                        }
                    }
                    window.location.replace((wkQueryParams.toString()=="")?"https://"+location.host+location.pathname:"https://"+location.host+location.pathname+"?"+wkQueryParams.toString());
                    return false;
                }
                if(!hypObj.is_multiple_filter && hypObj.$(this).is(":checked") && hypObj.$(this).data('for') != 'vendor' )
                hypObj.$('.wk-hl-prod-list-page .wk_hl_panel ul li input:checked').not(this).not('div#filter-pickup input:checked').not('div#filter-time-slot input:checked').not('div#filter-vendor input:checked').prop('checked', false);
                
                hypObj.getFilterdetails(false);
            });
            hypObj.$('body').on('click touchstart', '.wk-hl-close-single-filter', function(event) {
                var to_remove = hypObj.$(this).data('value');
                var query_for = hypObj.$(this).data('for');
                if(query_for=='store-pickup' || query_for=='time-slot'){
                    window.location.href = window.location.origin +hyobj_allproducts_url;
                    return 0;
                }
                hypObj.$(this).parent().remove();
                hypObj.$("[data-for='" + query_for + "']input[value='" + to_remove + "']").prop("checked", false);
                hypObj.getFilterdetails(false);
            });
            hypObj.$('body').on('click touchstart', '.wk-hl-filter-clear-all', function(event) {
                if(hypObj.$('.wk-hl-prod-list-page #filter-pickup ul li input:checked').length || hypObj.$('.wk-hl-prod-list-page #filter-time-slot ul li input:checked').length ){
                    window.location.href = window.location.origin +hyobj_allproducts_url;
                }
                else{
                    hypObj.getFilterdetails(true);
                }
            });
            hypObj.$('body').on('click', '.wk-hl-pagination .wk-hl-page', function(e) {
                if (hypObj.$(".wk_hyp_allproducts").length > 0)
                    hypObj.$(window).scrollTop(480);
                else
                    hypObj.$(window).scrollTop(40);
                var current_page = hypObj.$(this).data('page');
                hypObj.getAllProductsDetailBySellerIds(current_page,false);
            });
            if(hypObj.current_page_path.includes('search') || hypObj.current_page_path.includes('collections')){
                console.log('Reached to Page :: ' + hypObj.current_page_path);
                hypObj.shop_name = Shopify.shop
                let wk_customer_location = window.localStorage.getItem('wk_customer_location');
                if (typeof wk_customer_location != 'undefined' && wk_customer_location != '') {
                    let product_ids = []
                    hypObj.$('.wk-search-list').each(function() {
                        product_ids.push(hypObj.$(this).data('prod-id'));
                    });
                    if (product_ids.length > 0) {
                        hypObj.restrictSearchedProduct(hypObj.$.parseJSON(wk_customer_location), product_ids);
                    }
                }
            }
            hypObj.$('.wk-hl-prod-list-page').on('click', '.wk-hl-accordion', function(e) {
                this.classList.toggle("wk-active");
                var wk_hl_panel = this.nextElementSibling;
                if (wk_hl_panel.style.maxHeight) {
                wk_hl_panel.style.maxHeight = null;
                } else {
                wk_hl_panel.style.maxHeight = ((wk_hl_panel.scrollHeight>hypObj.wk_hl_200)?hypObj.wk_hl_200:wk_hl_panel.scrollHeight) + "px";
                }
            });
            hypObj.$('.wk-hl-prod-list-page').on('click', '.wk-hl-sidebar-toggle', function(e) {
                document.getElementById("wk-hl-slide-filter-id").classList.toggle("wk-hl-stc");      
                document.getElementById("wk-hl-wrapper-overlay").classList.toggle("wk-hl-full-width");
            });

            hypObj.$('.wk-hl-prod-list-page').on('change', '.wk_hl_prod_sort select', function(e) {
                var sort_by = hypObj.$(this).val();
                hypObj.getAllProductsDetailBySellerIds(1,false,sort_by); 
            });
            
            // if(hypObj.$('.wk_hyperlocal').length)
            // {
            //     // var storedIds = JSON.parse(window.localStorage.getItem("wk_seller_ids"));

            // }

        });
    })

}).call(this);
// console.log(window);